/* eslint-disable no-param-reassign */

import counterUp from 'counterup2';

/**
 * Function to detect if a given element is in the viewport.
 */
function isElementInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0
    && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight));
}

function initNumberCounter() {
  const numberCounters = document.querySelectorAll('.wp-block-riverdale-number-counter');

  /**
   * Function to determine whether we should run the animation on the number element.
   */
  function animationCheck(numberCounterEl, numberInputEl) {
    if (
      isElementInViewport(numberCounterEl)
      && numberInputEl.getAttribute('data-has-been-animated') === 'false'
    ) {
      numberInputEl.setAttribute('data-has-been-animated', 'true');
      counterUp(numberInputEl, {
        duration: 2000,
        delay: 16,
      });
    }
  }

  if (numberCounters) {
    numberCounters.forEach((el) => {
      const numberInputEl = el.querySelector('.riverdale-number-counter__numberInput');
      numberInputEl.setAttribute('data-has-been-animated', 'false');
      /**
       * Needs to run straight away in case numbers are visible on page load. Otherwise, they
       * won't animate until the user scrolls.
       */
      animationCheck(el, numberInputEl);
      window.addEventListener('scroll', () => {
        animationCheck(el, numberInputEl);
      });
    });
  }
}

window.addEventListener('load', () => {
  initNumberCounter();
});
